<div class="es-shell">
  <div class="container">
    
    <!-- HEADER -->
    <div class="es-header">
      <div class="es-title-block">
        <div class="icon-box">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
            <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
            <line x1="12" y1="22.08" x2="12" y2="12"></line>
          </svg>
        </div>
        <div class="title-text">
          <h1>Pedidos Prontos para Separação</h1>
          <p>Selecione um pedido abaixo para iniciar o processo de conferência e separação no estoque.</p>
        </div>
      </div>

      <!-- Badge da empresa filtrada -->
      <div class="badge-empresa-tela" *ngIf="!legadoAberto"
           [style.background]="empresaState.corClaraPorCodEmp(empresaState.selecionada, 0.78)"
           [style.border-color]="empresaState.corPorCodEmp(empresaState.selecionada)">
        <span class="badge-empresa-dot" [style.background]="empresaState.corPorCodEmp(empresaState.selecionada)"></span>
        <span class="badge-empresa-texto">
          Empresa {{ empresaState.selecionada }}<ng-container *ngIf="nomeEmpresaAtual"> — {{ nomeEmpresaAtual }}</ng-container>
        </span>
      </div>

      <!-- Quando a fonte é o Sistema Legado (Aerosys), a "empresa" relevante não
           é mais a do Sankhya (empresaState) e sim a empresa do Aerosys sendo
           consultada -- vira um seletor aqui mesmo (nasce já na empresa 1 por
           padrão ou na última lembrada; troca a qualquer momento sem precisar
           de card/tela à parte, ver carregarLegadoEmpresas/onLegadoEmpresaSelectChange). -->
      <div class="badge-empresa-tela badge-empresa-legado" *ngIf="legadoAberto">
        <span class="badge-empresa-dot dot-legado"></span>
        <span class="badge-empresa-texto" *ngIf="legadoEmpresasCarregando"><app-loading-indicator size="inline"></app-loading-indicator> Carregando empresas...</span>
        <select
          *ngIf="!legadoEmpresasCarregando"
          class="sel-empresa-legado"
          [ngModel]="legadoEmpresaSelecionada?.id ?? null"
          (ngModelChange)="onLegadoEmpresaSelectChange($event)"
          title="Empresa do Sistema Legado (Aerosys)"
        >
          <option *ngIf="!legadoEmpresaSelecionada" [ngValue]="null" disabled>Selecione a empresa...</option>
          <option *ngFor="let emp of legadoEmpresas" [ngValue]="emp.id">
            {{ emp.nome || emp.razao || ('Empresa ' + emp.id) }}
          </option>
        </select>
      </div>

      <!-- Indicador (não clicável) de que este usuário vê o Sistema Legado nesta
           tela — a fonte é definida pela permissão VERAERO, não por um toggle.
           Quem não tem a permissão nem vê este selo (vê os pedidos do Sankhya). -->
      <div *ngIf="podeVerVendasLegado" class="badge-fonte-legado" title="Esta tela mostra as vendas do Sistema Legado (Aerosys), não os pedidos do Sankhya">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2"></rect>
          <line x1="9" y1="9" x2="15" y2="9"></line>
          <line x1="9" y1="13" x2="15" y2="13"></line>
          <line x1="9" y1="17" x2="12" y2="17"></line>
        </svg>
        Sistema Legado
      </div>
    </div>

    <!-- Vendas do Sistema Legado (Aerosys): erros/estados da escolha de empresa
         (a própria empresa é escolhida no seletor do cabeçalho acima). -->
    <div *ngIf="legadoAberto && legadoEmpresasErro" class="alert alert-danger">{{ legadoEmpresasErro }}</div>
    <div *ngIf="legadoAberto && legadoErro" class="alert alert-danger">{{ legadoErro }}</div>
    <div *ngIf="legadoAberto && legadoEmpresaSelecionada == null && !legadoEmpresasCarregando && legadoEmpresas.length === 0 && !legadoEmpresasErro" class="alert alert-danger">
      Nenhuma empresa do Sistema Legado disponível para este usuário.
    </div>

    <!-- ERRO INICIAR -->
    <div *ngIf="erroIniciar" class="alert alert-danger">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
      {{ erroIniciar }}
    </div>

    <!-- ERRO -->
    <div *ngIf="erro" class="alert alert-danger">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
      {{ erro }}
    </div>

    <!-- LISTAGEM -->
    <div class="content-card" *ngIf="!aguardandoEscolhaEmpresaLegado">
      <div *ngIf="carregandoLinhas" class="loading-state">
        <app-loading-indicator></app-loading-indicator>
        <span>{{ legadoAberto ? 'Buscando vendas do Sistema Legado...' : 'Buscando pedidos autorizados...' }}</span>
      </div>

      <div *ngIf="!carregandoLinhas && linhas.length === 0 && !erro" class="empty-state">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"></path></svg>
        <h3>Fila Limpa!</h3>
        <p>{{ legadoAberto ? 'Não há vendas Autorizado/Separação no Sistema Legado no momento.' : 'Não há nenhum pedido aguardando separação no momento.' }}</p>
      </div>

      <div class="pedidos-grid" *ngIf="!carregandoLinhas && linhas.length > 0">
        <!-- Card de Pedido -->
        <div class="pedido-card" *ngFor="let p of linhas" [class.pedido-card-legado]="p.origem === 'aerosys'">

          <div class="card-header">
            <span class="nunota-badge">#{{ p.origem === 'aerosys' ? p.numTituloLegado : p.nunota }}</span>
            <div class="badges-right">
              <span class="badge badge-imediato" *ngIf="p.imediato === 'Sim'">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
                Imediato
              </span>
              <span class="badge badge-prioridade" [ngClass]="prioridadeClass(p.prioridade)">
                {{ p.prioridade || 'Normal' }}
              </span>
            </div>
          </div>

          <div class="card-body">
            <h3 class="cliente-nome">{{ p.nomeCliente }}</h3>

            <!-- Prefixo (Aeronave) -->
            <p *ngIf="p.prefixo" class="card-info-row card-prefixo-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.8 19.2L16 11l3.5-3.5C21 6 21 4 19.5 2.5S18 2 17 2l-3.5 3.5L5 4.2l-1.4 1.4 6.6 2.8-3 3-2.8-.7-1.4 1.4 4.6 2.4 2.4 4.6 1.4-1.4-.7-2.8 3-3z"></path></svg>
              <span class="card-info-label">Prefixo:</span>
              <span class="card-prefixo-badge">{{ p.prefixo }}</span>
            </p>

            <!-- Vendedor -->
            <p class="card-info-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
              <span class="card-info-label">Vendedor:</span> {{ p.vendedor }}
            </p>

            <!-- Separador + Data Início (qualquer separador — não só o usuário logado) -->
            <p *ngIf="emSeparacaoPorAlguem(p)" class="card-info-row card-sep-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
              <span class="card-info-label">Separador:</span>
              {{ p.sepNome && p.sepNome.trim() ? p.sepNome : (p.sepCodusu > 0 ? 'Separador #' + p.sepCodusu : 'Em separação') }}
            </p>
            <p *ngIf="emSeparacaoPorAlguem(p) && p.dataInicio" class="card-info-row card-datainicio-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
              <span class="card-info-label">Início:</span> {{ p.dataInicio }}
            </p>
            <p *ngIf="emSeparacaoPorAlguem(p) && p.numTag" class="card-info-row card-tag-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41 11 3.83A2 2 0 0 0 9.59 3.24H4a1 1 0 0 0-1 1v5.59a2 2 0 0 0 .59 1.41l9.58 9.59a2 2 0 0 0 2.82 0l4.6-4.6a2 2 0 0 0 0-2.82z"></path><circle cx="7.5" cy="7.5" r="1.5"></circle></svg>
              <span class="card-info-label">TAG:</span>
              <span class="card-tag-badge">{{ p.numTag }}</span>
            </p>

            <!-- Progresso (qualquer separador) -->
            <div *ngIf="emSeparacaoPorAlguem(p) && p.totalItens > 0" class="card-progresso">
              <div class="card-progresso-texto">
                <span>{{ p.qtdSeparados }} / {{ p.totalItens }} itens separados</span>
                <span class="card-progresso-pct">{{ p.totalItens > 0 ? ((p.qtdSeparados / p.totalItens) * 100 | number:'1.0-0') : 0 }}%</span>
              </div>
              <div class="card-progresso-bar">
                <div class="card-progresso-fill"
                     [style.width.%]="p.totalItens > 0 ? (p.qtdSeparados / p.totalItens) * 100 : 0">
                </div>
              </div>
            </div>

            <!-- Total itens (só AUTORIZADO — ninguém iniciou ainda) -->
            <p *ngIf="!emSeparacaoPorAlguem(p)" class="card-info-row card-itens-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>
              <span>{{ p.totalItens }} {{ p.totalItens === 1 ? 'item' : 'itens' }}</span>
            </p>
          </div>

          <div class="card-footer">
            <!-- Já em separação por este usuário (Sankhya) ou em SEPARAÇÃO no Sistema
                 Legado (sem validação de posse — qualquer usuário continua) → Continuar (verde) -->
            <button *ngIf="emSeparacao(p)"
                class="btn-continuar"
                (click)="continuarSeparacao(p)">
              <span>Continuar Separação</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
            </button>
            <!-- "Sininho" -- itens que estavam pendentes ("Item no outro Galpão") já
                 tiveram a pendência resolvida (alguém buscou) e voltaram pra fila "A
                 Separar" desta venda, aguardando o separador conferir/bipar de
                 verdade. Mesmo destino do botão Continuar -- é só um atalho chamativo
                 pra avisar que tem item pra finalizar. Existe tanto pro Sistema Legado
                 quanto pro fluxo nativo Sankhya (ver ITENS_PENDENCIA_RESOLVIDA em
                 SeparacaoComponent, GPL-Integracao backend). -->
            <button *ngIf="emSeparacao(p) && (p.itensPendenciaResolvida ?? 0) > 0"
                type="button"
                class="btn-sininho-pendencia"
                title="Itens que voltaram do outro galpão -- clique para finalizar a separação"
                (click)="continuarSeparacao(p)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
              <span class="sininho-badge">{{ p.itensPendenciaResolvida }}</span>
            </button>
            <!-- Em separação, mas por OUTRO separador (ex.: visão gerencial do SUP) →
                 só informa, sem oferecer ação que a pessoa vendo a tela não tem posse. -->
            <div *ngIf="separacaoDeOutro(p)" class="card-footer-info">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
              <span>Em separação por {{ p.sepNome && p.sepNome.trim() ? p.sepNome : 'outro separador' }}</span>
            </div>
            <!-- Ainda AUTORIZADO (Sankhya) → Iniciar (azul, funcional) -->
            <button *ngIf="!emSeparacaoPorAlguem(p) && p.origem !== 'aerosys'"
                class="btn-iniciar"
                (click)="iniciarSeparacao(p)"
                [disabled]="iniciandoNunota === p.nunota">
              <span *ngIf="iniciandoNunota !== p.nunota">Iniciar Separação</span>
              <span *ngIf="iniciandoNunota === p.nunota"><app-loading-indicator size="inline"></app-loading-indicator> Aguarde...</span>
              <svg *ngIf="iniciandoNunota !== p.nunota" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
            </button>
            <!-- Ainda AUTORIZADO (Aerosys) → Iniciar. Mesmo handler do botão verde
                 "Continuar Separação" (continuarSeparacao) -- pro Sistema Legado
                 iniciar e continuar são a mesma navegação (abre a tela de itens,
                 que pede TAG+usuário); é o backend (garantirSessaoAtiva) quem
                 decide se é a 1ª sessão da venda e só então grava VEN_STATUS =
                 "SEPARAÇÃO" + VEN_FUN_ID_SEP + VEN_DATA_SEP no cabeçalho. -->
            <button *ngIf="!emSeparacaoPorAlguem(p) && p.origem === 'aerosys'"
                type="button"
                class="btn-iniciar btn-iniciar-legado"
                (click)="continuarSeparacao(p)">
              <span>Iniciar Separação</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
            </button>
            <!-- Estornar para ABERTO (não disponível para separação de outro separador) -->
            <button *ngIf="podeEstornar(p)"
                type="button"
                class="btn-estornar"
                title="Estornar pedido para ABERTO"
                (click)="solicitarEstornar($event, p)"
                [disabled]="estornandoNunota === p.nunota">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path></svg>
              <span>Estornar</span>
            </button>
          </div>

        </div>
      </div>
    </div>

  </div>

  <!-- MODAL: Confirmar Estorno para ABERTO -->
  <div class="tag-modal-overlay" *ngIf="confirmandoEstorno" (click)="cancelarEstornar()">
    <div class="tag-modal-box" (click)="$event.stopPropagation()">
      <div class="tag-modal-header">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path></svg>
        <span>Estornar Pedido para Aberto</span>
      </div>

      <p class="tag-modal-subtitulo">
        Pedido <strong>#{{ confirmandoEstorno.nunota }}</strong> — {{ confirmandoEstorno.nomeCliente }}
      </p>

      <p class="tag-modal-aviso">
        O pedido sairá da fila de Separação e voltará para Aberto. O progresso de separação já feito neste pedido será apagado — será preciso iniciar a separação do zero.
      </p>

      <div *ngIf="erroEstornar" class="tag-modal-erro">{{ erroEstornar }}</div>

      <div class="tag-modal-footer">
        <button type="button" class="tag-modal-btn-cancelar"
                (click)="cancelarEstornar()"
                [disabled]="estornandoNunota !== null">
          Cancelar
        </button>
        <button type="button" class="tag-modal-btn-confirmar tag-modal-btn-perigo"
                (click)="confirmarEstornar()"
                [disabled]="estornandoNunota !== null">
          <span *ngIf="estornandoNunota === null">Confirmar Estorno</span>
          <span *ngIf="estornandoNunota !== null"><app-loading-indicator size="inline"></app-loading-indicator> Aguarde...</span>
        </button>
      </div>
    </div>
  </div>

  <!-- MODAL: Informar TAG (obrigatório antes de iniciar a separação) -->
  <div class="tag-modal-overlay" *ngIf="modalTagAberto" (click)="fecharModalTag()">
    <div class="tag-modal-box" (click)="$event.stopPropagation()">
      <div class="tag-modal-header">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41 11 3.83A2 2 0 0 0 9.59 3.24H4a1 1 0 0 0-1 1v5.59a2 2 0 0 0 .59 1.41l9.58 9.59a2 2 0 0 0 2.82 0l4.6-4.6a2 2 0 0 0 0-2.82z"></path><circle cx="7.5" cy="7.5" r="1.5"></circle></svg>
        <span>Informe o número da TAG</span>
      </div>

      <p class="tag-modal-subtitulo" *ngIf="pedidoParaIniciar">
        Pedido <strong>#{{ pedidoParaIniciar.nunota }}</strong> — {{ pedidoParaIniciar.nomeCliente }}
      </p>

      <input #tagInput
             type="text"
             class="tag-modal-input"
             [(ngModel)]="numTagDigitada"
             (ngModelChange)="onTagInputChange($event)"
             (keyup.enter)="confirmarInicioComTag()"
             placeholder="00"
             maxlength="2"
             autocomplete="off"
             inputmode="numeric"
             pattern="[0-9]*">

      <div *ngIf="erroModalTag" class="tag-modal-erro">{{ erroModalTag }}</div>

      <p class="tag-modal-aviso">Informe o número da TAG (01 a 40) para iniciar a separação.</p>

      <div class="tag-modal-footer">
        <button type="button" class="tag-modal-btn-cancelar"
                (click)="fecharModalTag()"
                [disabled]="iniciandoNunota !== null">
          Cancelar
        </button>
        <button type="button" class="tag-modal-btn-confirmar"
                (click)="confirmarInicioComTag()"
                [disabled]="!numTagDigitada.trim() || iniciandoNunota !== null">
          <span *ngIf="iniciandoNunota === null">Confirmar e Iniciar</span>
          <span *ngIf="iniciandoNunota !== null"><app-loading-indicator size="inline"></app-loading-indicator> Aguarde...</span>
        </button>
      </div>
    </div>
  </div>
</div>
